import {Injectable, NgZone} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AlertController, LoadingController, Platform} from '@ionic/angular';
import {Socket} from 'ngx-socket-io';
import {Observable, firstValueFrom, throwError} from 'rxjs';
import {map, catchError, share} from 'rxjs/operators';
import {SocketOneProvider} from '../socket-one/socket-one';
import {SocketTwoProvider} from '../socket-two/socket-two';
import {AjaxAppender, Logger, LoggingService} from 'ionic-logging-service';
import {SipProvider} from '../sip/sip';
import {ConfigurationService} from '../configuration.service';
import {Events} from '../events';
import { PageController } from 'src/app/page-controller/page.controller';
import {Page} from 'src/app/page-controller/page.type';

declare let window: any;

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
  _user: any = {token: ''};
  _userFallback: any = {token: ''};
  url = '/api';
  socketConnect = false;
  socket: Socket;
  isApp = (!document.URL.startsWith('http') || document.URL.indexOf('http://localhost/') !== -1);
  isBrowser = !this.isApp;
  isFallBack = false;
  appicon = '';
  splashbg = '';
  backendUrl = '';
  initTimeOut: any;
  private timeOut: any;
  
  private loading: HTMLIonLoadingElement;
  private logger: Logger;
  private switchAlertDanger: HTMLIonAlertElement;
  private loadingTimeOut: any;


  constructor(public socketOne: SocketOneProvider, public socketTow: SocketTwoProvider, private loadingCtrl: LoadingController,
              private alertCtrl: AlertController, public http: HttpClient, public platform: Platform, private events: Events,
              public loggingService: LoggingService, private sipProvider: SipProvider, public config: ConfigurationService, private pageController:PageController, private ngZone: NgZone) {

    if (localStorage.getItem('hnr-token')) {
      this._user = JSON.parse(localStorage.getItem('hnr-token'));
    }

    if (localStorage.getItem('hnr-token-fallback')) {
      this._userFallback = JSON.parse(localStorage.getItem('hnr-token-fallback'));
    }

    
    

    this.socketOne.on('connect', () => {
      if (this.isFallBack) {
        this.getLoggerInst().info('socketOneConnect', {
          message: 'Zurück zum MasterServer',
          person: this._user.profile.firstname + ' ' + this._user.profile.lastname
        });
        this.socket = this.socketOne;
        this.backendUrl = this.socketOne.ioSocket.io.uri;
        this.isFallBack = false;
        
        this.events.publish('switchSocket');
        if (this.switchAlertDanger) {
          this.switchAlertDanger.dismiss();
        }

        this.sipProvider.isFallBack = false;
        this.sipProvider.unregister();
        this.sipProvider.registerSIPConnection();
      }
    });


    this.socketOne.removeAllListeners('getConnectedClient');
    this.socketOne.on('getConnectedClient', this._getClientInfo.bind(this));

    const f1 = () => {
      this.events.publish('socketConnect');

      if (this._user.profile) {
        this.socket.emit('user-connect', {}[this._user.user_id] = this.socket.ioSocket.id);
      }

      this.events.publish('switchSocket');

      this.ngZone.run(() => {
        console.log('socketConnect 1', true);
        this.socketConnect = true;
      });

      if (this.timeOut) {
        clearTimeout(this.timeOut);
      }
      if (this.initTimeOut) {
        clearTimeout(this.initTimeOut);
      }

      this.hideLoading();

      if (this.switchAlertDanger) {
        this.switchAlertDanger.dismiss();
      }

      if(this._user.token) {
        this.sipProvider.registerSIPConnection();
      }
    }

    this.socketOne.on('connect', f1);
    this.socketTow.on('connect', f1);

    const f2 = () => {
      this.showLoading();

      this.ngZone.run(() => {
        console.log('socketConnect 2', false);
        this.socketConnect = false;
      });

      this.timeOut = setTimeout(() => {
        this.getLoggerInst().info('socketDisconnect', {
          message: 'Socket disconnect',
          person: this._user.profile.firstname + ' ' + this._user.profile.lastname
        });
        this.switchConnect();
      }, 15000);
    }

    this.socketOne.on('disconnect', f2);
    this.socketTow.on('disconnect', f2);

    this.socket = this.socketOne;
    this.socketConnect = this.socket.ioSocket.connected;

    if(this._user.token && this.socketConnect ) {
      this.sipProvider.registerSIPConnection();
    }

  }

  private getLoggerInst() {
    if(this.logger) {
      return this.logger;
    }
    this.logger = this.getLogger('Hausnotruf.ApiConnection');
    return this.logger;
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }

  private _getClientInfo() {
    if (this._user && this._user.profile) {
      this.socket.emit('connectedClient', new Date().toISOString() + ' ' + this._user.profile.firstname + ' ' + this._user.profile.lastname);
    }
  }

  async switchProvider(provData: any) {
    this.appicon = provData.appicon;
    this.splashbg = provData.splashbg;
    localStorage.setItem('appicon', provData.appicon);
    localStorage.setItem('splashbg', provData.splashbg);
    localStorage.setItem('providerKey', provData.providerKey);

    const mergeConfig = {};
    this.config.getKeys().forEach((key) => {
      mergeConfig[key] = this.config.getValue(key);
    });

    Object.assign(mergeConfig, provData);

    const url = URL.createObjectURL(new Blob([JSON.stringify(mergeConfig)], {
      type: 'text/plain'
    }));

    await this.config.load(url)

    this.events.publish('switchProvider');
  }

  switchSocketUrl(socketUrl, secSocketUrl) {
    this.socketOne.disconnect();
    this.socketTow.disconnect();
    this.socketOne.ioSocket.io.uri = socketUrl;
    this.socketTow.ioSocket.io.uri = secSocketUrl;

    window.localStorage.setItem('socketUrl', socketUrl);
    window.localStorage.setItem('secSocketUrl', secSocketUrl);

    this.backendUrl = socketUrl;
    setTimeout(() => {
      this.socketOne.connect();
      this.socketTow.connect();
    }, 4500);

  }

  public getLogger(logPath: string): Logger {
    const ajaxAppender: any = new AjaxAppender({
      url: this.config.getValue('socketUrl').toString() + '/service/saveFrontendLog',
      batchSize: 10,
      timerInterval: 60000,
      threshold: 'ALL'
    });

    ajaxAppender.ajaxAppender.addHeader('Authorization', 'Bearer ' + this._user.token + ':' + this._user.password);

    const logger = this.loggingService.getLogger(logPath);
    logger.getInternalLogger().addAppender(ajaxAppender);
    return logger;
  }

  public updateProfile(fieldId: string, data: any): Observable<any> {

    const firstHeader = new HttpHeaders({
      Authorization: 'Bearer ' + this._user.token + ':' + this._user.password
    });

    return this.http.post(this.socket.ioSocket.io.uri + '/auth/update/' + fieldId, data, {headers: firstHeader});
  }

  test() {
    console.log(this.socket.ioSocket.io.uri);
    return firstValueFrom(this.http.get(this.socket.ioSocket.io.uri  + '/service/test'));
  }

  private async showLoading() {
    this.loadingTimeOut = setTimeout(async () => {
      this.loading = await this.loadingCtrl.create({
        message: 'Verbindung zum Server verloren. Verbindung wird aufgebaut',
        duration: 5000
      });
      this.loading.present();
    }, 4500);
  }

  private hideLoading() {
    if (this.loadingTimeOut) {
      clearTimeout(this.loadingTimeOut);
      setTimeout(async () => {
        if (this.loading) {
          this.loading.dismiss();
          this.loading = null;
        }
      }, 1600);
      this.loadingTimeOut = null;
    }
    if (this.loading) {
      this.loading.dismiss();
      this.loading = null;
    }
  }

  async switchConnect() {
    if(this.socket.ioSocket.connected) {
      return;
    }
    // this.socket.disconnect();
    this.socket = this.socketTow;
    this.socket.connect();
    if (this.socket.ioSocket.connected) {
      if (this._user?.profile?.firstname) {
        this.getLoggerInst().info('switchConnect', 'SlaveServer aktive', {person: this._user.profile.firstname + ' ' + this._user.profile.lastname});
      }
      this.backendUrl = this.config.getValue('secSocketUrl').toString();

      this.ngZone.run(() => {
        console.log('socketConnect 3', true);
        this.socketConnect = true;
      });

      this.isFallBack = true;
      
      this.hideLoading();
      this.events.publish('switchSocket');
      if (this.switchAlertDanger) {
        this.switchAlertDanger.dismiss();
      }

      this.sipProvider.isFallBack = true;
      this.sipProvider.unregister();

      if(localStorage.getItem('prom')) {
        this.sipProvider.registerSIPConnection();
      }
    } else {
      // this.socket.disconnect();
      this.socket = this.socketOne;
      this.socket.connect();
      if (this.socket.ioSocket.connected) {
        this.ngZone.run(() => {
          console.log('socketConnect 4', true);
          this.socketConnect = true;
        });
        this.hideLoading();
        this.events.publish('switchSocket');
        if (this.switchAlertDanger) {
          this.switchAlertDanger.dismiss();
        }
      } else {
        this.ngZone.run(() => {
          console.log('socketConnect 5', true);
          this.socketConnect = false;
        });
        this.hideLoading();

        if (this._user?.profile) {
          this.getLoggerInst().error('switchConnect', 'kein Verbindung zum Server', {person: this._user.profile.firstname + ' ' + this._user.profile.lastname});
        }

        this.switchAlertDanger = await this.alertCtrl.create({
          header: 'Achtung',
          subHeader: 'Es konnte kein Verbindung zum Server hergestellt werden.',
          message: 'Prüfen Sie Ihre Internetanbindung.<br>Oder wenden Sie ich an den Support!<br><br>' + this.config.getValue('socketUrl'),
          cssClass: 'alert-danger',
          buttons: ['Schließen']
        });

        await this.switchAlertDanger.present();
        await this.switchAlertDanger.onDidDismiss();
        this.switchAlertDanger = null;
      }
    }
  }

  get(endpoint: string, params: any = {}) {

    const sendParams = {requestId: endpoint + new Date().getTime(), json: params, token: ''};
    if (this._user.token) {
      sendParams.token = this.getToken();
    }

    this.socket.emit('GET:/' + endpoint, sendParams);

    return this.socket.fromEvent('GET:' + sendParams.requestId).pipe(map(this.handleError.bind(this)), catchError((res: Response) => throwError(() => new Error(res.statusText))));
  }

  checkLogin(token, password) {
    const sendParams = {requestId: 'login' + new Date().getTime(), json: {credentials: {token, password}}, token};

    this.socket.emit('POST:/' + 'login', sendParams);
    return this.socket.fromEvent('POST:' + sendParams.requestId).pipe(map(this.handleError.bind(this)), catchError((res: Response) => throwError(() => new Error(res.statusText))));
  }

  post(endpoint: string, body: any, token = '') {

    if (endpoint !== 'login') {
      token = this.getToken();
    }

    const sendParams = {requestId: endpoint + new Date().getTime(), json: body, token};

    this.socket.emit('POST:/' + endpoint, sendParams);
    return this.socket.fromEvent('POST:' + sendParams.requestId).pipe(map(this.handleError.bind(this)), catchError((res: any) => throwError(() => { const d:any = res.err.data || res.message;  return new Error(d) })));
    // .map(this.handleError);
  }

  postSocket2(endpoint: string, body: any, token = '') {
    if (endpoint !== 'login') {
      token = this.getToken(true);
    }

    const sendParams = {requestId: endpoint + new Date().getTime(), json: body, token};

    this.socketTow.emit('POST:/' + endpoint, sendParams);
    return this.socketTow.fromEvent('POST:' + sendParams.requestId).pipe(map(this.handleError.bind(this)));
    // .map(this.handleError);
  }

  put(endpoint: string, params: any = {}, token = '') {
/**
 * This class provides methods to interact with the API.
 * It includes methods for HTTP requests such as GET, POST, PUT, PATCH and DELETE.
 * It also includes methods for user authentication such as login, signup and logout.
 */
    token = this.getToken();

    const sendParams = {requestId: endpoint + new Date().getTime(), json: params, token};

    this.socket.emit('PUT:/' + endpoint, sendParams);

    return this.socket.fromEvent('PUT:' + sendParams.requestId).pipe(map(this.handleError.bind(this)), catchError((res: Response) => throwError(() => new Error(res.statusText))));
  }

  delete(endpoint: string, body: any, token = '') {
    token = this.getToken();

    const sendParams = {requestId: endpoint + new Date().getTime(), json: body, token};

    this.socket.emit('DELETE:/' + endpoint, sendParams);
    return this.socket.fromEvent('DELETE:' + sendParams.requestId).pipe(map(this.handleError.bind(this)), catchError((res: Response) => throwError(() => new Error(res.statusText))));
  }

  patch(endpoint: string, body: any, token = '') {
    token = this.getToken();

    const sendParams = {requestId: endpoint + new Date().getTime(), json: body, token};

    this.socket.emit('PATCH:/' + endpoint, sendParams);
    return this.socket.fromEvent('PATCH:' + sendParams.requestId).pipe(map(this.handleError.bind(this)), catchError((res: Response) => throwError(() => new Error(res.statusText))));
  }

  private getToken(getFallback = false) {
    if(this.isFallBack || getFallback) {
      return this._userFallback.token + '::' + this._userFallback.password;
    }
    return this._user.token + '::' + this._user.password;
  }

  private handleError(res: any) {
    if (res.status === 403) {
      console.log(res.err);
      this.getLoggerInst().error('handleError', 'Status 403', res);
      this.clearStorage();
      this.pageController.navigateRoot(Page.Login);
      throw res;
    } else if (res.status === 500) {
      console.log(res.err);
      this.getLoggerInst().error('handleError', 'Status 500', res);
      throw res;
    } else {
      return res;
    }
  }

  /**
   * Send a POST request to our login endpoint with the data
   * the user entered on the form.
   */
  async login(accountInfo: any) {
      accountInfo.credentials.username = unescape(encodeURIComponent(accountInfo.credentials.username.toLowerCase()));
      accountInfo.credentials.password = unescape(encodeURIComponent(accountInfo.credentials.password));

      console.log('login connected', this.socket.ioSocket.connected);

      if(!this.socket.ioSocket.connected) {
        await this.switchConnect();
      }

     
      try {
        console.log('socket uri', this.socket.ioSocket.io.uri);
        const seq = this.http.post(this.socket.ioSocket.io.uri + '/auth/login', accountInfo.credentials).pipe(share());
        const res:any = await firstValueFrom(seq);
        await firstValueFrom(this.checkLogin(res.token, res.password).pipe(share()));
        res.provider = accountInfo.credentials.provider;

          if(!this.isFallBack) {
            try {
              const resp = await firstValueFrom(this.http.post(this.socketTow.ioSocket.io.uri + '/auth/login', accountInfo.credentials));
              this._loggedInFallBack(resp);
            } catch (error) {
              console.log('FALLBACK', error);
            }
          }

          if(this.isFallBack) {
            this._loggedInFallBack(res);
          } else {
            this._loggedIn(res);
          }

          return(true);

      } catch (error) {
        throw new Error(error);
      }
  }

  /**
   * Send a POST request to our signup endpoint with the data
   * the user entered on the form.
   */
  signup(accountInfo: any) {
    const seq = this.post('signup', accountInfo).pipe(share());

    seq.subscribe({next:(res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.status === 'success') {
        this._loggedIn(res);
      }
    }, error: (err) => {console.error('ERROR', err);}})
    return seq;
  }

  /**
   * Log the user out, which forgets the session
   */
  async logout() {
    

    try {
      const firstHeader = new HttpHeaders({
        Authorization: 'Bearer ' + this._user.token + ':' + this._user.password
      });
      await firstValueFrom(this.http.post(this.socketOne.ioSocket.io.uri + '/auth/logout', {}, {headers: firstHeader}))
    } catch (error) {
      console.log('LOGOUT', error);
    }

    try {
      const firstHeader = new HttpHeaders({
        Authorization: 'Bearer ' + this._userFallback.token + ':' + this._userFallback.password
      });
      await firstValueFrom(this.http.post(this.socketTow.ioSocket.io.uri + '/auth/logout', {}, {headers: firstHeader}))
    } catch (error) {
      console.log('LOGOUT', error);
    }
    
    
    this.events.publish('unregisterFCM', this._user);

    this.clearStorage();
    this.sipProvider.logout();

    if (window.FirebasePlugin) {
      window.FirebasePlugin.unregister();
    }
  }

  private clearStorage() {
    this._user = {token: ''};
    localStorage.setItem('hnr-token', '{}');
  }

  /**
   * Process a login/signup response to store user data
   */
  private _loggedIn(resp) {
    localStorage.setItem('hnr-token', JSON.stringify(resp));
    this._user = resp;


    if (localStorage.getItem('hnr-callNumber')) {
      this._user.profile.callNumber = localStorage.getItem('hnr-callNumber');
    }
  }

  /**
   * Process a login/signup response to store user data
   */
  private _loggedInFallBack(resp) {
    localStorage.setItem('hnr-token-fallback', JSON.stringify(resp));
    this._userFallback = resp;
    this._user = resp;

    if (localStorage.getItem('hnr-callNumber')) {
      this._userFallback.profile.callNumber = localStorage.getItem('hnr-callNumber');
    }
  }

  updateHnrToken(key: string, value: any) {
    if (key === 'callNumber') {
      localStorage.setItem('hnr-callNumber', value);
    }

    this._user.profile[key] = value;
    localStorage.setItem('hnr-token', JSON.stringify(this._user));
  }

  getAdressData() {
    return JSON.parse(localStorage.getItem('addressData'));
  }

  getProm() {
    return localStorage.getItem('prom');
  }

}
